export const getInitialState = (): any => ({
  uploadModelStatusData: {}
});
